import { callOverlay } from '@/Groups/OverlayManager/public/utils/callOverlay';

let swRegistration = null;

/**
 * Регистрирует Workbox-скомпилированный service-worker.js и
 * уведомляет пользователя при появлении новой версии.
 */
export async function registerServiceWorker() {
  if (!('serviceWorker' in navigator)) return null;

  try {
    // Удаляем устаревший SW от push-уведомлений (был /service-worker-custom.js)
    const registrations = await navigator.serviceWorker.getRegistrations();
    for (const reg of registrations) {
      if (reg.active && reg.active.scriptURL.includes('service-worker-custom')) {
        await reg.unregister();
      }
    }

    const registration = await navigator.serviceWorker.register('/service-worker.js');
    swRegistration = registration;

    // Новая версия SW ожидает активации
    registration.addEventListener('updatefound', () => {
      const newWorker = registration.installing;
      if (!newWorker) return;

      newWorker.addEventListener('statechange', () => {
        // SW установлен и ждёт активации, при этом уже есть активный SW (т.е. это обновление, а не первая установка)
        if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
          callOverlay({
            text: 'Доступно обновление. Перезагрузите страницу.',
            color: 'blue',
            icon: 'refresh',
          });
        }
      });
    });

    // При обновлении SW (не первой установке) — перезагружаем
    const hadController = !!navigator.serviceWorker.controller;
    let refreshing = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (!hadController || refreshing) return;
      refreshing = true;
      window.location.reload();
    });

    return registration;
  } catch (error) {
    console.error('SW registration failed:', error);
    return null;
  }
}

/**
 * Возвращает текущую регистрацию SW (для push и других модулей).
 */
export function getSwRegistration() {
  return swRegistration;
}
